export type Coach = {
  id: string;
  name: string;
  email: string;
};

export const COACHES: Coach[] = [
  {
    id: '488ec938-7a0b-4b1f-99b0-111d2b36582c',
    name: 'Casey D. Boardroom',
    email: 'casey.boardroom@example.com',
  },
];
